<template>
  <div class="card donate-info">
    <h2 class="card__title">
      {{ project.name }}
    </h2>

    <PagesProjectDonateColected
      :project="project"
      :finished="finished"
      :locale="locale"
      @open-donate-modal="$emit('open-donate-modal')"
    />

    <div class="donate-info__modal-cards">
      <PagesProjectSponsorModal
        v-if="project.sponsor"
        :sponsor="project.sponsor"
      />

      <PagesProjectPromoModal
        v-if="profilePromo"
        :promo="profilePromo"
        :promo-invited="profilePromoInvited"
        :locale="locale"
      />

      <PagesProjectFundModal
        :fund-id="project.fundBasicData.id"
        :fund-basic-data="project.fundBasicData"
      />

      <div v-if="finished" class="donate-finish">
        <svgo-finish-donate width="24px" height="24px" class="icon" />
        <p>{{ $t('donate.completed') }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import useProfileStore from '~/store/profile';
defineEmits(['open-donate-modal']);

defineProps({
  project: {
    type: Object,
    default: () => ({}),
  },
  locale: {
    type: String,
    default: 'en',
  },
  finished: {
    type: Boolean,
    default: false,
  },
});

const profileStore = useProfileStore();
const profilePromo = computed(() => profileStore.getPromotion);
const profilePromoInvited = computed(() => profileStore.getPromotionInvited);
</script>

<style lang="scss">
@use '@styles/components/pages/project/donateInfo.scss' as *;
</style>
